import React from 'react'
import { ISavedReportsListContext } from './interfaces'

export const SavedReportsListContext = React.createContext<ISavedReportsListContext>({} as ISavedReportsListContext)
